import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const ConfigurationService = {
    getAll: async () => {
        const res = await axios.get(ENDPOINT.Configuration);
        return res.data;
    },
    getByType: async (type) => {
        const res = await axios.get(`${ENDPOINT.Configuration}/${type}`);
        return res.data;
    },
    create: async (payload) => {
        const res = await axios.post(ENDPOINT.Configuration, payload);
        return res.data;
    },
    update: async (id, payload) => {
        const res = await axios.put(`${ENDPOINT.Configuration}/${id}`, payload);
        return res.data;
    },
    delete: async (id) => {
        const res = await axios.delete(`${ENDPOINT.Configuration}/${id}`);
        return res.data;
    },
};